export default {
    'PDF': 'application/pdf', 
    'DOC': 'application/msword',
    'DOCX': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'TXT': 'text/plain',
    'XLSX': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'CSV': 'text/csv'
}